import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navItems, siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-300/40'
          : 'bg-gradient-to-b from-background-50/90 to-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5 group" onClick={() => setMenuOpen(false)}>
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center font-heading font-bold text-lg">
            月
          </span>
          <span className="leading-none">
            <span className="block font-heading font-semibold tracking-wide text-foreground-950 text-lg group-hover:text-primary-400 transition-colors">
              {siteInfo.brand}
            </span>
            <span className="block text-[10px] tracking-[0.3em] text-foreground-500 mt-0.5">
              {siteInfo.tagline}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.key}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm transition-colors cursor-pointer ${
                  isActive
                    ? 'text-primary-400 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/episodes"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-fill" />
            立即观看
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/60 transition-colors cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-background-300/40 bg-background-50/95 backdrop-blur-md px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.key}
                to={item.path}
                end={item.path === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-500/15 text-primary-400 font-medium'
                      : 'text-foreground-700 hover:bg-background-200/60'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}